import React from "react";
// Chakra imports
import { Flex, Text, useColorModeValue, SimpleGrid } from "@chakra-ui/react";
import Card from "components/card/Card";
// Custom components
import InnerContent from "layouts/innerContent";

export default function Numbers() {
	// Chakra Color Mode

	const textColor = useColorModeValue("#09090B", "white");
	return (
		<Flex
			zIndex='2'
			w='100%'
			direction={{ base: "column" }}
			bgSize='cover'
			position='relative'
			pt={{ base: "90px", md: "100px", xl: "160px" }}
			pb={{ base: "90px", md: "100px", xl: "160px" }}>
			<InnerContent px={{ base: "20px", md: "40px", xl: "0px" }} maxW='100%'>
				<Flex direction='column' width='stretch'>
					<Flex
						direction='column'
						mx='auto'
						alignItems='center'
						textAlign='center'>
						<Text
							as='h3'
							textAlign={{ base: "center", lg: "center" }}
							fontWeight='700'
							letterSpacing='2px'
							color={textColor}
							fontSize={{ base: "xs", md: "md" }}
							w='100%'
							mb='10px'>
							OUR WORK EXPERIENCE IN NUMBERS
						</Text>
						<Text
							as='h2'
							textAlign={{ base: "center" }}
							color={textColor}
							fontWeight='800'
							fontSize={{ base: "28px", md: "48px", lg: "48px", xl: "48px" }}
							lineHeight={{ base: "38px", md: "60px", lg: "60px", xl: "60px" }}
							mb={{ base: "20px", md: "20px" }}
							w={{ base: "70%", md: "58%", lg: "100%", xl: "100%" }}
							mx='auto'>
							Our experience in a few numbers
						</Text>
						<Text
							color='#52525B'
							fontSize={{ base: "md", md: "md", xl: "lg" }}
							fontWeight='500'
							letterSpacing='0px'
							lineHeight={{ base: "24px", md: "30px" }}
							w={{
								base: "92%",
								md: "90%",
								lg: "90%",
								xl: "64%",
								"2xl": "54%",
							}}>
							With Virtualizm Dev at our side, overcoming challenges becomes
							effortless. We've partnered to help you manage even the most
							demanding projects smoothly. Together, we support your path to
							project success.
						</Text>
					</Flex>
				</Flex>
				<Flex
					display={{ base: "none", xl: "block" }}
					flexDirection='row'></Flex>
				<SimpleGrid
					columns={{ md: "2", lg: "2", xl: "4" }}
					mt={{ base: "40px", xl: "60px" }}
					spacing='20px'
					w={{ lg: "100%", xl: "1170px" }}>
					<Card
						w='100%'
						alignItems='center'
						justifyContent='center'
						borderRadius={{ base: "10px", md: "16px" }}
						py='42px'
						px={{ base: "70px", md: "22px", lg: "50px", xl: "22px" }}>
						<Text
							as='h3'
							mx='auto'
							mt='-18px'
							fontSize={{ base: "40px", md: "40px", lg: "50px", xl: "60px" }}
							fontWeight='700'
							textAlign='center'
							letterSpacing='0px'
							color={textColor}>
							50+
							<Text
								ms='2px'
								textAlign='center'
								fontSize='md'
								fontWeight='600'
								color='#52525B'>
								Delivered Projects
							</Text>
						</Text>
					</Card>
					<Card
						w='100%'
						alignItems='center'
						justifyContent='center'
						borderRadius={{ base: "10px", md: "16px" }}
						py='42px'
						px={{ base: "70px", md: "22px", lg: "50px", xl: "22px" }}>
						<Text
							as='h3'
							mx='auto'
							mt='-18px'
							fontSize={{ base: "40px", md: "40px", lg: "50px", xl: "60px" }}
							fontWeight='700'
							textAlign='center'
							letterSpacing='0px'
							color={textColor}>
							30+
							<Text
								ms='2px'
								textAlign='center'
								fontSize='md'
								fontWeight='600'
								color='#52525B'>
								Clients Worldwide
							</Text>
						</Text>
					</Card>
					<Card
						w='100%'
						alignItems='center'
						justifyContent='center'
						borderRadius={{ base: "10px", md: "16px" }}
						py='42px'
						px={{ base: "40px", md: "22px", lg: "50px", xl: "22px" }}>
						<Text
							as='h3'
							mx='auto'
							mt='-18px'
							fontSize={{ base: "40px", md: "40px", lg: "50px", xl: "60px" }}
							fontWeight='700'
							textAlign='center'
							letterSpacing='0px'
							color={textColor}>
							95%
							<Text
								ms='2px'
								textAlign='center'
								fontSize='md'
								fontWeight='600'
								color='#52525B'>
								Avg. Client Satisfaction Rate
							</Text>
						</Text>
					</Card>
					<Card
						w='100%'
						alignItems='center'
						justifyContent='center'
						borderRadius={{ base: "10px", md: "16px" }}
						py='42px'
						px={{ base: "70px", md: "22px", lg: "50px", xl: "22px" }}>
						<Text
							as='h3'
							mx='auto'
							mt='-18px'
							fontSize={{ base: "40px", md: "40px", lg: "50px", xl: "60px" }}
							fontWeight='700'
							textAlign='center'
							letterSpacing='0px'
							color={textColor}>
							6+
							<Text
								ms='2px'
								textAlign='center'
								fontSize='md'
								fontWeight='600'
								color='#52525B'>
								Years in Operation
							</Text>
						</Text>
					</Card>
				</SimpleGrid>
			</InnerContent>
		</Flex>
	);
}
